import React, {Dispatch, SetStateAction, useEffect, useState} from 'react';
import {useHistory, useParams} from 'react-router';

import UserData from '../components/UserData';
import npsService, {NpsData} from '../services/npsService';
import RateBase from '../components/RateBase';
import styled from 'styled-components';
import {Box} from '@material-ui/core';

const StyledBox = styled(Box)`
margin-top: 20px;
`;

const Nps = () => {
  const history = useHistory();
  const {hash} = useParams();
  const [data, setData]: [NpsData | null, Dispatch<SetStateAction<any>>] = useState(
      null);

  // component created hook
  useEffect(() => {
    const getNps = async () => {
      try {
        const res = await npsService.getNps(hash);
        setData(res.data);
        if (res.data.user_id) {
          const metricsData = await npsService.getUserData(+res.data.user_id);
          for (const [key, val] of Object.entries(metricsData)) {
            if (key === 'ut_id') {
              continue;
            }
            metricsData[key] = +(val as string);
          }
          metricsData['userId'] = res.data.user_id;
          npsService.addVisitYaParams(metricsData);
          npsService.addUserYaMetrics(metricsData);
        }
      } catch (e) {
        history.push('/');
      }
    };
    getNps().then();
  }, [history, hash]);

  if (data) {
    return (
        <>
          <UserData userId={data!.user_id} userName={data!.user_name}/>
          <StyledBox>
            <RateBase question={data!.question}/>
          </StyledBox>
        </>
    );
  }

  return null;
};

export default Nps;
